module.exports = __webpack_public_path__ + "static/img/mastercard-straight-128px.79bbbfa1.png";